function mmSlideProductReassurance() {
    var splideElemMain = document.querySelector("#slider-reassurance");
    // SLIDER PRODUCT
    if (splideElemMain) {
        var main = new Splide(splideElemMain, {
            type: "slide",
            rewind: true,
            pagination: true,
            arrows: false,
            autoplay: true,
            interval: 5000,
            perPage: 1,
        });
        main.mount();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    mmSlideProductReassurance();
});

// read more bundle
function mmReadMoreAvis(extractSelector, fullSelector) {
	var extracts = document.querySelectorAll(extractSelector);
	var fulls = document.querySelectorAll(fullSelector);

	// Vérifier si la longueur des deux sélections est la même
	if (extracts.length !== fulls.length) {
		console.error('Les listes ne sont pas de même longueur.');
		return;
	}
	for (var i = 0; i < extracts.length; i++) {
		var extract = extracts[i];
		var full = fulls[i];

		extract.style.display = (extract.style.display === 'block') ? 'none' : 'block';
		full.style.display = (full.style.display === 'block') ? 'none' : 'block';
	}
}

// Ouverture des dropdowns
var allDropdown = document.querySelectorAll(".mm-product-form-dropdown");
allDropdown.forEach((content) => {
    content.addEventListener("click", function () {
        checkDropdown(content, false);
    });
    checkDropdown(content, true);
});

function checkDropdown(dropdown, load) {
    if (load && dropdown.classList.contains("active")) {
        const content = dropdown.nextElementSibling;
        content.style.height = content.scrollHeight + "px";
    } else if (!load) {
        dropdown.classList.toggle("active");
        const content = dropdown.nextElementSibling;
        if (content.style.height) {
            content.style.height = null;
        } else {
            content.style.height = content.scrollHeight + "px";
        }
        allDropdown.forEach((elem) => {
            if (elem != dropdown) {
                elem.classList.remove("active");
                elem.nextElementSibling.style.height = null;
            }
        });
    }
}

// change qtty
function mmChangeQtty(delta, inputId) {
	var input = document.getElementById(inputId);
	if (delta == "-1" && input.value == "1") {
	} else {
    var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
    input.value = newValue;
		mmUpdatePrice(newValue);
	}
}

function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll(".mm-update-price");

	priceAll.forEach(function(price) {
		var promoQtty = parseFloat(price.dataset.promoQuantity);
		let promoPrice = parseFloat(price.dataset.promoPrice);
		var unitPrice = parseFloat(price.dataset.value) / 100; // Prix à l'unité en euros
		var totalPrice;

		if (!isNaN(promoQtty) && qtty >= promoQtty && promoPrice) {
			totalPrice = (promoPrice * qtty) / 100;
		} else {
			totalPrice = unitPrice * qtty;
		}
		var formattedPrice = totalPrice.toFixed(2);
		var euros = Math.floor(totalPrice);
		var cents = Math.round((totalPrice - euros) * 100);
		price.innerHTML = euros + "€" + (cents > 0 ? cents : ""); // Affichage
	});
}

// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var CTA = document.querySelector('.sticky-btn');

function mmCtaSticky(position_scroll) {
	if (position_scroll > 768) {
		CTA.classList.add('mm-cta-sticky');
	} else {
		CTA.classList.remove('mm-cta-sticky');
	}
}

window.addEventListener('scroll', function(e) {
	derniere_position_de_scroll_connue = window.scrollY;

	if (!ticking) {
		window.requestAnimationFrame(function() {
		mmCtaSticky(derniere_position_de_scroll_connue);
		ticking = false;
		});
	}
});

class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			this.variantFetch();
			this.updateCTA();
		}

		window.addEventListener('scroll', function(e) {
			derniere_position_de_scroll_connue = window.scrollY;

			if (!ticking) {
				window.requestAnimationFrame(function() {
					mmCtaSticky(derniere_position_de_scroll_connue);
					ticking = false;
				});
			}
		});
	}

	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}


	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter(".mm-update-price", html);
		this.updateElementOuter(".mm-product-price-total", html);
		this.updateElementOuter(".mm-product-form-variant-option", html);
		this.updateElementOuter(".mm-btn-main-product", html);
		this.updateElementOuter(".mm-pf-modal-add-bottom", html);
	}

	updateCTA() {
		const stickyCTAbis = document.querySelector('.mm-wrapper-update-price');
		stickyCTAbis.querySelector('.mm-update-price').innerText = `${this.currentVariant.price / 100} €`;

		if (this.currentVariant.available) {
			stickyCTA.classList.remove('mm-btn-disabled');
		} else {
			stickyCTA.classList.add('mm-btn-disabled');
		}
	}

	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) {
			// Vérifiez si l'élément à mettre à jour est le CTA
			if (selector === ".mm-cta-sticky") {
				destination.innerHTML = source.innerHTML;
				destination.classList.add('mm-cta-sticky');
			} else {
				destination.outerHTML = source.outerHTML;
			}
		}
	}
}

customElements.define("variant-selector", VariantSelector);

/* Modal add to cart */
const PRODUCT_FORM_ID_NAME = document.getElementById("product-form");
const MODAL_CLASS_NAME = PRODUCT_FORM_ID_NAME.querySelector('.mm-pf-modal-add-to-card-container');
function mmShowModalProduct() {
	if (MODAL_CLASS_NAME) {
			MODAL_CLASS_NAME.classList.add("active");
			// Fermer la modal après 4 secondes
			setTimeout(mmCloseModalProduct, 4000);
	}
}

function mmCloseModalProduct() {
	MODAL_CLASS_NAME.classList.remove("active");
}
